import React, { useState } from 'react';
import './Booking.css';

const Booking = () => {
  const [service, setService] = useState('');
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [location, setLocation] = useState('');
  const [days, setDays] = useState('');

  const handleBooking = (e) => {
    e.preventDefault();
    alert`(Booking Confirmed for ${service}\nDate: ${date}\nTime: ${time}\nPickup: ${location}\nDays: ${days})`;
    
  };

  return (
    <div className="booking-container">
      <h2>A premium, chauffeur-based experience – from arrival to farewell.</h2>
      <p>Global ground transport for the world’s top tier</p>

      <div className="service-buttons">
        {['Airport Transfer', 'Full Day Chauffeur', 'City To City Rides', 'Car Rental', 'Meet & Greet'].map((item) => (
          <button
            key={item}
            className={service === item ? 'active' : ''}
            onClick={() => setService(item)}
          >
            {item}
          </button>
        ))}
      </div>

      <form onSubmit={handleBooking} className="booking-forms">
        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} required />
        <input type="time" value={time} onChange={(e) => setTime(e.target.value)} required />
        <input type="text" placeholder="Pick Up Location" value={location} onChange={(e) => setLocation(e.target.value)} required />
        <input type="number" placeholder="Days" value={days} onChange={(e) => setDays(e.target.value)} required />
        <button type="submit" className="book-now-btnn">Book Now</button>
      </form>
    </div>
  );
};

export default Booking;